import { createSlice } from '@reduxjs/toolkit'
const img1 = "/assets/images/clients/passport.jpg";
const img2 = "/assets/images/clients/agent.png";
const uxtech = '/assets/projects/uxtech.png';
const bsc = '/assets/projects/bsc.png';
const msbank = '/assets/projects/msbank.png';
const shopafrica = '/assets/projects/shopafrica.png';
const nupe = '/assets/projects/nupe.png';
const clientSlice = createSlice({
    name: 'clients',
    initialState: {
      payload: [
        {
          img: nupe,
          title: 'Cultural and Heritage Preservation Portal',
          description: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
          position: 'Chief Executive Officer',
          color: 'white',
          company: 'Nupe Kingdom Portal'
        },
        {
          img: shopafrica,
          title: 'E-Commerce Web and Mobile Application.',
          description: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
          position: 'Chief Technology Officer',
          color: 'black',
          company: 'Textng Comm (Shop Africa).'
        },
        {
          img: img1,
          title: 'Campaign Management System.',
          description: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
          position: 'Chief Executive Officer',
          color: 'black',
          company: 'o4WIN'
        },
        {
            img: msbank,
            title: 'Banking Web and Mobile Application.',
            description: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'Chief Technology Officer',
            color: 'white',
            company: 'Marasoft Pay.'
          },
          {
            img: bsc,
            title: 'Sport Club Portal and Management System',
            description: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'Chief Executive Officer',
            color: 'white',
            company: 'Bida Sport Club'
          },
          {
            img: uxtech,
            title: 'Telecommunication Web and Mobile Application',
            description: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'Chief Technology Officer',
            color: 'white',
            company: 'UX ELITE TECHNOLOGIES (UXTECH).'
          },
          
      ]
    }
    ,
    reducers: {
        clients: (state, action) => {
            state.sliders = action.payload;
        }
    }
})

export const {clients} = clientSlice.actions;
export default clientSlice.reducer;
